/**
 * View for selecting the action item type in the wizard
 */
define([
  "marionette",
  "modules/actions/actionGroup/actionItemModal/actionItemSelect/template/actionItemSelectTemplate.html",
], function (Marionette, ActionItemSelectTemplate) {
  var ActionItemSelectView = {};

  ActionItemSelectView.actionItemSelectView = Marionette.ItemView.extend({
    template: ActionItemSelectTemplate,
    triggers: {
      "click #apiRequestTile": "open:api:request",
      "click #transformationActionTile": "open:transformation",
    },
  });

  return ActionItemSelectView;
});
